/* eslint-disable */ import { memoEval, sceneEntityPropertiesComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('Legs').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('Legs').attach(memoEval((self)=>[
            self.$offsetY
        ], ($offsetY)=>({
            offsetY: $offsetY
        })))
];

//# sourceMappingURL=legs.js.map